module.exports = __webpack_public_path__ + "img/w4.ac1bc9a5.png";